
<div class="d-flex  justify-content-center" *ngIf="cargandoDatos">
    <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
      <span class="sr-only">Loading...</span>
    </div>
</div>
<div class="d-flex  justify-content-center pt-3" *ngIf="cargandoDatos">
    <h3>{{ 'CSV.LOADING' | translate }}</h3>    
</div>
<ngx-spinner [name]="'csv_viewer_spinner'" bdColor  = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate" [fullScreen] = "true">
  <p style="color: white" >{{mensajeSpinner}}</p>
</ngx-spinner> 

<div class="container-pdf-div col-12">
  <div class="container-pdf-div-buttons col-md-8  col-sm-12"  *ngIf="!cargandoDatos">
    <h3>{{ 'CSV.VALID' | translate }}</h3>    
    <button type="button" class="btn btn-primary" (click)="openPdf(documento)"><span class="incon-button-details"></span>{{ 'COMMON.BUTTON.DOWNLOAD' | translate }}</button>    
  </div>
  <div #pdfContainer class="container-pdf col-md-8 col-sm-12">
      <!-- Las páginas del PDF se añadirán aquí dinámicamente -->
  </div>
</div>

 